import { useTheme } from "@/context/ThemeContext";

export default function LanguageSwitcher() {
  const { language, setLanguage } = useTheme();

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-border bg-background/80 p-1 shadow-sm backdrop-blur"
      role="group"
      aria-label={language === "en" ? "Language" : "Lingua"}
      data-testid="language-switcher"
    >
      {["it", "en"].map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLanguage(code)}
          aria-pressed={language === code}
          className={`rounded-full px-2.5 py-1 text-[10px] font-medium tracking-[0.12em] transition-colors ${
            language === code
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:bg-muted hover:text-foreground"
          }`}
          data-testid={`language-${code}`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
